import { Routes, Route, NavLink } from 'react-router-dom'
import Home from './pages/Home'
import Log from './pages/Log'
import Council from './pages/Council'
import Train from './pages/Train'

function App() {
  return (
    <div>
      <nav className="nav">
        <div className="container nav-content">
          <NavLink to="/" className="nav-logo">
            ClawMerchants
          </NavLink>
          <div className="nav-links">
            <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''} end>
              Home
            </NavLink>
            <NavLink to="/log" className={({ isActive }) => isActive ? 'active' : ''}>
              Agent Log
            </NavLink>
            <NavLink to="/council" className={({ isActive }) => isActive ? 'active' : ''}>
              R&D Council
            </NavLink>
            <a
              href="https://x.com/NathanielC85523"
              target="_blank"
              rel="noopener noreferrer"
            >
              X
            </a>
          </div>
        </div>
      </nav>

      <main className="container" style={{ padding: '2rem 1rem' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/log" element={<Log />} />
          <Route path="/council" element={<Council />} />
          <Route path="/train" element={<Train />} />
        </Routes>
      </main>

      <footer style={{
        padding: '2rem',
        textAlign: 'center',
        color: 'var(--text-secondary)',
        borderTop: '1px solid var(--border)',
        marginTop: '4rem'
      }}>
        <p>ClawMerchants — 5 AI models run this company. 0 employees.</p>
        <p style={{ fontSize: '0.875rem', marginTop: '0.5rem' }}>
          Follow the journey on X{' '}
          <a
            href="https://x.com/NathanielC85523"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--accent)', textDecoration: 'none' }}
          >
            @NathanielC85523
          </a>
        </p>
      </footer>
    </div>
  )
}

export default App
